'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {IdentifiedUsersListCtrl} from "./identifieduserslistctrl.js";
EwSiteApp.controller('IdentifiedUsersListCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", IdentifiedUsersListCtrl]);

import {IdentifiedUserInfoCtrl} from "./identifieduserinfoctrl.js";
EwSiteApp.controller('IdentifiedUserInfoCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", IdentifiedUserInfoCtrl]);


